import { Box, Container } from "@mui/material";
import RichTextEditor from "../../../LandingPage/RichTextEditor";
import reportStyles from "./Report.styles";

const PdfConvertor = (props: any) => {
  //   const redirectionState = props.location?.state;
  const classes = reportStyles;

  return (
    <>
      <Box sx={classes.mainContainer}>
        <Box sx={classes.mainBox}>
          <Box sx={classes.subBox}>
            <Container maxWidth="lg" sx={{ px: 1 }}>
              <RichTextEditor
                content={props.content || ""}
                handleContent={() => {}}
                title={"Editor"}
                needExportButton
                fileName={props.fileName || ""}
                fileTitle={props.fileTitle || ""}
                fileSubTitle={props.fileTitle || ""}
              />
            </Container>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default PdfConvertor;
